<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoFuentesFinancieras" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :fuenteFinanciera="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoFuentesFinancierasDesktop',
  props: {
    listadoFuentesFinancieras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        { text: 'Origen', value: 'origen' },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
